const en: Record<string, string> = {
  'features.meals.empty': 'No meals planned yet.',
  'features.meals.exportPdf': 'Export PDF',
  'features.meals.newMeal': 'New meal',
  'features.meals.title': 'Title',
  'features.meals.titlePlaceholder': 'Optional',
  'features.meals.untitled': 'Untitled meal',
  'features.meals.date': 'Date',
  'features.meals.headcount': 'Headcount',
  'features.meals.headcountValue': '{{count}} persons',
  'features.meals.headcountShort': '{{count}}p.',
  'features.meals.mealTime': 'Meal',
  'features.meals.slot.morning': 'Morning',
  'features.meals.slot.midday': 'Midday',
  'features.meals.slot.evening': 'Evening',
  'features.meals.cancel': 'Cancel',
  'features.meals.create': 'Create',
  'features.meals.delete': 'Delete meal',
  'features.meals.archive': 'Archive',
  'features.meals.readMode': 'Read mode',
  'features.meals.close': 'Close',
  'features.meals.description': 'Description',
  'features.meals.participants': 'Participants',
  'features.meals.selectParticipants': 'Select participants',
  'features.meals.selectRecipes': 'Select recipes',
  'features.meals.recipes': 'Recipes',
  'features.meals.noRecipes': 'No recipes in this project yet.',
};

export default en;
